import { requisitionConfirmationProductListStyles } from "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationProductList";
import { css } from "styled-components";
import { COLORS } from "@tKgpco/theme/design";

Object.assign(requisitionConfirmationProductListStyles, {
    ...requisitionConfirmationProductListStyles,
    cartLinesList: {
        wrapper: {
            css: css`
                margin-top: 20px;
            `,
        },
        cardExpanded: {
            productDescriptionAndPartNumbersGridItem: {
                width: [12, 12, 6, 12, 6],
            },
            productPriceAndQuantityGridItem: {
                width: [12, 12, 12, 12, 12],
            },
            priceGridItem: {
                width: [5, 4, 4, 4, 4],
                css: css`
                    span[data-test-selector^="productPrice_unitNetPrice"] {
                        color: rgb(30, 117, 186);
                    }
                `,
            },
            quantityGridItem: {
                width: [7, 4, 4, 4, 4],
                css: css`
                    & div {
                        margin-top: 0px;
                        flex-direction: row;
                        align-items: center;
                        border-radius: 8px;
                        background-color: #e1e7ed;
                        color: ${COLORS.lightBlack};
                        p {
                            text-align: center;
                            padding: 8px;
                            width: 100%;
                            justify-content: center;
                            margin-bottom: 0 !important;
                            font-size: 14px;
                        }
                    }
                `,
            },
            extendedUnitNetPriceGridItem: {
                width: [12, 4, 4, 4, 3],
            },
        },
    },
});
